import React, { useEffect, useRef, useState } from 'react';
import "./homepagecomponents.css"
import img1 from "./images/homepage-img1.jpg"
import avatar1 from "./images/avatar1.jpg"
import avatar2 from "./images/avatar2.jpg"
import avatar3 from "./images/avatar3.jpg"
import avatar4 from "./images/avatar4.jpg"
import avatar5 from "./images/avatar5.jpg"
import avatar6 from "./images/avatar6.jpg"

const HomepageComp1 = () => {

  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container homepage-comp1-container overflow-hidden ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div className='grid grid-cols-2 relative gap-[50px]'>

        <div>
          <div className='homepage-comp1-div1'>
            <div>Eco-Friendly Mining</div>
            <p>Experience gold mining with Merge Turk Gold, where sustainability meets innovation.</p>
          </div>

          <h1 className='homepage-title1'> Mining Responsibly, Innovating Sustainably</h1>

          <p className='homepage-text1'> Engage with our commitment to environmentally responsible mining practices utilizing advanced technology for sustainable outcomes. </p>

          <a className='homepage-link1 z-2 relative' href="/coming-soon">Learn About Our Mission</a>
        </div>

        <div className='h-full flex items-end justify-center'>
          <div className='homepage-comp1-div2 z-2'>
            <div className='flex -space-x-2 overflow-hidden p-2 lg:mb-5'>
              <img class="" src={avatar1} alt="" />
              <img class="" src={avatar2} alt="" />
              <img class="" src={avatar3} alt="" />
              <img class="" src={avatar4} alt="" />
              <img class="" src={avatar5} alt="" />
            </div>
            <div className='text-xl text-white'>
              <span className='text-2xl font-semibold lg:text-4xl'>5,500</span> <span className='ml-2'>Community Partnerships</span>
            </div>
          </div>
        </div>

        <img class="home-comp1-avatar6 z-2" src={avatar6} alt="mother-kid" />
        <svg class="absolute -bottom-20 right-0 z-0 hidden lg:block" width="1044" height="140" viewBox="0 0 1044 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.00006 44.5C88.6667 84.3333 354.9 157.3 546.5 44.4999C738.1 -68.3001 957.833 73.3333 1042 138" stroke="#E9E9E9" stroke-width="3" stroke-linecap="round" stroke-dasharray="20 20"></path>
        </svg>
      </div>

      <img class="homepage-comp1-topimg absolute shadow-md -right-32 -top-32 z-10 hidden h-[750px] w-[750px] rounded-full rounded-tr-none object-cover object-right-top md:block" src={img1} alt="hero" />


    </div>
  )
}

export default HomepageComp1